module.exports = __webpack_public_path__ + "intuit-card-bottom-left.2ZT0pGX-.png";